import type { ThreadSummary } from "@/entities/thread";
import { TagFilter } from "@/features/catalog/components/TagFilter";
import { Modal } from "@/shared/ui/overlay";

interface TagFilterModalProps {
  isOpen: boolean;
  threads: ThreadSummary[];
  onClose: () => void;
}

export function TagFilterModal({
  isOpen,
  threads,
  onClose,
}: TagFilterModalProps): React.ReactElement {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="フィルタ"
      position="bottom"
      flickToClose={false}
    >
      <TagFilter threads={threads} className="m-4 px-0 pb-0" />
    </Modal>
  );
}
